import { useLayoutEffect, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocalStorage } from 'react-use';
import { useGeoIp } from '@srcDS/hooks/useGeoIp';

const useGeoIpBanner = () => {
  let bannerHeight = 0;
  const [show, setShow] = useState(true);
  const [isBannerClosed, setIsBannerClosed] = useLocalStorage(
    'isCountryBannerClosed',
  );
  const [isRender, setIsRender] = useState(false);

  const getBannerHeight = () => {
    bannerHeight =
      typeof document !== 'undefined' &&
      document.getElementById('geoBanner')?.clientHeight;
  };
  const { locale } = useSelector((state) => state.app.context);
  const currentLocale = locale === 'en_AU@NZD' ? 'NZ' : 'AU';
  const { isoCode } = useGeoIp();

  const isShowBanner = () => {
    if (isoCode && (isoCode === 'AU' || isoCode === 'NZ')) {
      if (
        (currentLocale === 'AU' && isoCode !== currentLocale) ||
        (currentLocale === 'NZ' && isoCode !== currentLocale)
      ) {
        return true;
      }
    }

    return false;
  };

  useLayoutEffect(() => {
    const shouldShow = !isBannerClosed?.state && show && isShowBanner();
    setIsRender(shouldShow);
    getBannerHeight();
  }, [show, isBannerClosed, isoCode]);

  useEffect(() => {
    const shouldShow = !isBannerClosed?.state && show && isShowBanner();
    if (shouldShow !== isRender) {
      setIsRender(shouldShow);
    }
  }, [isoCode]);


  const closeModal = () => {
    setShow(false);
    setIsBannerClosed({
      state: true,
    });
  };

  return { closeModal, setShow, isBannerClosed, bannerHeight, isRender };
};

export default useGeoIpBanner;
